export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/linkedin.63b66704.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};